import * as React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material'

/**
 * Creating context
 */
export const ErrorContext = React.createContext()

/**
 * Context provider component
 */
export const ErrorProvider = ({ children }) => {
  const [error, setError] = React.useState(null)
  const [open, setOpen] = React.useState(false)

  const showError = (message) => {
    setError(message)
    setOpen(true)
  }

  const closeError = () => setOpen(false)

  return (
    <ErrorContext.Provider value={{ showError }}>
      {children}

      <Dialog
        open={open}
        onClose={closeError}
        maxWidth="xs"
        fullWidth
        TransitionProps={{
          onExited: () => setError(null)
        }}
      >
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <Typography>{error}</Typography>
        </DialogContent>
        <DialogActions sx={{ p: 4, gap: 1 }}>
          <Button variant="contained" onClick={closeError}>OK</Button>
        </DialogActions>
      </Dialog>
    </ErrorContext.Provider>
  )
}
